import Vue from 'vue'

Vue.directive('autocomplete', {
  bind(el, binding, vnode) {
    el.setAttribute('autocomplete', binding.value)
  }
})
